<script setup lang="ts">
import { computed } from 'vue'

import { Button, PopoverConfirm } from '@collector/shared-ui'
import {
  BaseballEventDetailId,
  BaseballEventStatusId,
  BaseballIncidentId,
} from '@collector/sportsapi-client-legacy'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEvent } from '@desktop/views/Relation/composables'
import { useEventIncidentsQueue } from '@desktop/views/Relation/Sports/composables'

import { useEventDetailHalf } from '../../../../composables'
import { inningEventStatuses } from '../../../../configuration'

// composables
const { event } = useEvent()
const { eventDetailHalfValue } = useEventDetailHalf()
const eventIncidentsQueue = useEventIncidentsQueue()

// computed
const isTopHalf = computed(() => eventDetailHalfValue.value === 'top')

const isButtonDisabled = computed(() => {
  return !inningEventStatuses.includes(
    event.value?.status_id as BaseballEventStatusId,
  )
})

// methods
async function changeToBottom(): Promise<void> {
  await sportsApiClient.Events.patch(event.value.id, {
    details: { [BaseballEventDetailId.Half]: 'bottom' },
  })
  eventIncidentsQueue.addIncident({
    incident_id: BaseballIncidentId.ResetStats,
  })
  eventIncidentsQueue.addIncident({
    incident_id: BaseballIncidentId.TVTimeout,
  })
}
</script>

<template>
  <PopoverConfirm
    v-if="isTopHalf"
    cancelLabel="No"
    confirmLabel="Yes"
    @confirm="changeToBottom"
  >
    <template #confirmText>
      <div class="w-30">
        <div>Do you want to</div>
        <div>change to Bottom?</div>
      </div>
    </template>
    <template #trigger>
      <Button
        class="w-35 font-bold disabled:cursor-default"
        size="sm"
        variant="action"
        :disabled="isButtonDisabled"
      >
        Change to Bottom
      </Button>
    </template>
  </PopoverConfirm>
  <Button
    v-else
    class="text-neutral-dark-3! w-35 font-bold"
    disabled
    size="sm"
    variant="highlighted"
  >
    Current: Bottom
  </Button>
</template>
